import { render, staticRenderFns } from "./PDF.vue?vue&type=template&id=04c8473a&scoped=true&"
import script from "./PDF.vue?vue&type=script&lang=js&"
export * from "./PDF.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c8473a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/administrador/developments/dtouch/dtouch-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFileInput } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {VCheckbox,VDivider,VFileInput,VIcon,VTextField,VToolbar,VToolbarTitle})
